import { useQuery } from "@tanstack/react-query";
import { pageStateQueryOptions } from "@/lib/queries";

export function usePageState(pageSlug: string) {
  return useQuery(pageStateQueryOptions(pageSlug));
}
